// extracted by mini-css-extract-plugin
export default {"spinner__container":"spinner_spinner__container__cpWKr","spinner__body":"spinner_spinner__body__3N9F+","spin":"spinner_spin__mqBxw"};